import script from "./Activity_Test0522.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity_Test0522.vue?vue&type=script&setup=true&lang=js"

import "./Activity_Test0522.vue?vue&type=style&index=0&id=18db4e83&lang=less&scoped=true"
import "./Activity_Test0522.vue?vue&type=style&index=1&id=18db4e83&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18db4e83"]])

export default __exports__